function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useRef, useState, useEffect } from 'react';

/**
 * Detect if the user clicked (`mousedown` or `touchstart`) inside a React `ref` `HTMLElement`.
 * @param options UseClickInsideOptions<T>
 * @returns UseClickInsideState
 */
var useClickInside = function useClickInside(options) {
  var callback = options.callback,
    _options$delay = options.delay,
    delay = _options$delay === void 0 ? 300 : _options$delay,
    ref = options.ref;
  var savedCallback = useRef(callback);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    clickedInside = _useState2[0],
    setClickedInside = _useState2[1];
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(function () {
    if (clickedInside && delay > -1) {
      setTimeout(function () {
        setClickedInside(false);
      }, delay);
    }
  }, [clickedInside]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    var listener = function listener(e) {
      var current = ref.current;
      // clicked inside the ref
      if (current && current.contains(e === null || e === void 0 ? void 0 : e.target)) {
        setClickedInside(true);
        if (savedCallback.current) {
          savedCallback.current(e);
        }
      } else {
        setClickedInside(false);
      }
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref]);
  return {
    clickedInside: clickedInside
  };
};
export { useClickInside };